/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import { Autocomplete, FormControl } from '@mui/material';
import TextField from '@mui/material/TextField';
import { CategoryDto, useProductCategoriesControllerRetrieveCategoriesQuery } from '@services';
import { useAppSelector } from '../../../../app/hooks';
import { selectCurrentMerchantId } from '../../auth/authSlice';

interface CategoryTagFilterComponentProps {
    value: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement> | { target: { name: string, value: any } }) => void,
    merchantId?: number,
}

const CategoryTagFilterComponent: FC<CategoryTagFilterComponentProps> = (props) => {
    const { value, onChange, merchantId: propMerchantId } = props;
    const merchantId = propMerchantId ?? useAppSelector(selectCurrentMerchantId) ?? 0;
    const { data: categoriesList } = useProductCategoriesControllerRetrieveCategoriesQuery({ merchantId });

    return (
        <FormControl fullWidth data-testid="CategoryTagFilterComponent">
            <Autocomplete
                multiple
                disableClearable
                disableListWrap
                size="small"
                limitTags={1}
                getOptionLabel={(o) => o.name!}
                value={categoriesList?.filter((allCat) => value?.split(',').some((c) => c === allCat.name)) ?? []}
                onChange={(event: any, newValue: CategoryDto[] | null) => onChange({
                    target: {
                        name: 'categoryTags',
                        value: newValue?.map((c) => c.name).join(',') ?? '',
                    },
                })}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Category Tags"
                        variant="outlined"
                        multiline={false}
                    />
                )}
                options={categoriesList || []}
            />
        </FormControl>
    );
};

export default CategoryTagFilterComponent;

CategoryTagFilterComponent.defaultProps = {
    merchantId: undefined,
};
